import React from "react";
import styled from "styled-components";

const InformationIcon = ({ children, ...props }) => {
    return (
        <Icon {...props}>
            {children}
        </Icon>
    );
};

const Icon = styled.div`
  background-color: var(--aia-bx-dark-blue);
  color: var(--aia-bx-white);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 0px;
  align-self: flex-start;
  margin-top: 2px;
  flex-shrink: 0;
`;

export default InformationIcon;